import React,{useEffect} from 'react';
import { useLocation } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles, withStyles } from '@mui/styles';
import {Grid, Box, Card, CardContent, CardHeader,
    Typography,Checkbox , TextField,
    FormGroup , FormControlLabel , FormControl , FormLabel, ToggleButton, ToggleButtonGroup 
} from '@mui/material';
import ButtonUnstyled, { buttonUnstyledClasses } from '@mui/core/ButtonUnstyled';
import { styled } from '@mui/system';
import { useHistory } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';


const THEME = createTheme({
    typography: {
     "fontFamily": `"PromptMedium","PromptSemiBold", "PromptRegular","PromptBold"`
    },
    palette: {
        primary: {
          main: '#7f51f5',
        }
      },
 });

const useStyles = makeStyles({
    body : {
        marginTop: '-3%'
    },
    headerTitle : {
        fontWeight: 'bold'
    },
    appbar: {
        alignItems: 'center',
    },
    textColor: {
        fontSize: '18px',
        color: '#7F51F5'
    },
    size12 :{
        fontSize : '13px'
    },
    redText: {
        color: 'red',
        textAlign: 'center',
        fontSize: '14px'
    },
    textField : {
        [`& fieldset`] :{
            borderRadius: '40px',
            borderColor: '#D2C4F8',
            width: '90%'
        }
    },
    iconSize: {
        position: 'absolute',
        paddingLeft: '10px',
        marginTop: '15px'
    }
});

const CustomButtonRoot = styled('button')(`
  background-color: #7F51F5;
  padding: 15px 50px;
  border-radius: 20px;
  color: #fff;
  font-weight: 600;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  transition: all 200ms ease;
  cursor: pointer;
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0);
  border: none;

  &:hover {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.active} {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }
`);

const CustomButtonRootBack = styled('button')(`
  background-color: #c7c7c7;
  padding: 15px 50px;
  border-radius: 20px;
  color: #fff;
  font-weight: 600;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  transition: all 200ms ease;
  cursor: pointer;
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0);
  border: none;

  &:hover {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.active} {
    background-color: #c7c7c7;
  }

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }
`);

function CustomCloseBack(props) {
    return <ButtonUnstyled {...props} component={CustomButtonRootBack} />;
}  

function CustomButton(props) {
    return <ButtonUnstyled {...props} component={CustomButtonRoot} />;
}

function ScrollToTopOnMount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    return null;
}

function Temperature() {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const [bodyTemp, setBodyTemp] = React.useState();
    const [heartRate, setHeartRate ] = React.useState();
    const [checkInput, setCheckInput] = React.useState(false);
    const [lang, setLang] = React.useState(localStorage.getItem('language'));

    const routeChange = () =>{ 
        if(bodyTemp && heartRate){
            setCheckInput(false);
            console.log("bodytemp:", bodyTemp);
            if(bodyTemp) {
                localStorage.setItem("bodyTemp", bodyTemp);
            }else{
                localStorage.setItem("bodyTemp", 0);
            }
            
            if(heartRate){
                localStorage.setItem("heartRate", heartRate);
            }else{
                localStorage.setItem("heartRate", 0);
            }
            let path; 
            // let path ='/chooseNumberOfTimes';
            // if(localStorage.getItem('projectKeyForm') === 'a82b9f65c583921083e8ff0089ed9e44ed8eb8a3' || localStorage.getItem('projectKeyForm') === 'egoey4j6avjc5rv3jkxktthj6ovqkubmdhg2hrq6'){
                path ='/chooseTimes'; 
            // }else{
            //     path = `/blood_pressure`;
            // }
            history.push(path);
        }else{
            setCheckInput(true);
        }
        
    }

    const handleChangeLanguage = (event) => {
        console.log("language change:" , event.target.value);
        setLang(event.target.value);
        localStorage.setItem('language', event.target.value);
        i18n.changeLanguage(localStorage.getItem("language"));
    };

    return (
        <ThemeProvider theme={THEME}>
        <br/>
        <div className={classes.body}>
            <ScrollToTopOnMount/>
            <div style={{float : 'right', marginRight: '18px'}}>
                <ToggleButtonGroup
                    color="primary"
                    value={lang}
                    exclusive
                    onChange={handleChangeLanguage}
                    size="small"
                >
                    <ToggleButton value="en">English</ToggleButton>
                    <ToggleButton value="th">ภาษาไทย</ToggleButton>
                </ToggleButtonGroup>
            </div>
            <br/>

            <Box sx={{ flexGrow: 1 }} pt={3}>
                <Grid container pl={2} pr={2}>
                    
                    <Grid item  md={12} xs={12}>
                        <Card sx={{ minWidth: 275 }} variant="outlined" style={{borderRadius: '15px', borderColor: '#D2C4F8'}}>
                        <CardHeader
                            subheader={t('bodyTemp')}
                            subheaderTypographyProps={{color:'#fff', fontSize: '12px' }}
                            style={{ paddingLeft:'33px', backgroundColor: '#7F51F5',color: '#fff' }}

                        />
                            <CardContent>
                                <FormGroup style={{paddingLeft: '20px'}}>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend" style={{color: 'black', fontSize: '13px'}}>
                                        {t('fillNumber')}
                                    </FormLabel>
                                    <br/>
                                    <TextField 
                                    className={classes.textField}
                                    value = {bodyTemp}
                                    onChange={event => setBodyTemp(event.target.value)}
                                     id="outlined-basic" label="" variant="outlined" size="small"
                                     type="number"
                                     InputProps={{
                                        inputProps: { 
                                            max: 100, min: 0,
                                            style: { paddingLeft: '12%' }
                                        },
                                    }}
                                    error={bodyTemp> 100}
                                    helperText={bodyTemp > 100 ? 'Please fill value between 0 and 100' : ''}
                                    />
                                        
                                    </FormControl>
                                </FormGroup>
                            </CardContent>
                        </Card>
                    </Grid>
                    
                </Grid>     
            </Box>


            <Box sx={{ flexGrow: 1 }} pt={3}>
                <Grid container pl={2} pr={2}>
                    
                    <Grid item  md={12} xs={12}>
                        <Card sx={{ minWidth: 275 }} variant="outlined" style={{borderRadius: '15px', borderColor: '#D2C4F8'}}>
                        <CardHeader
                            subheader={t('heartRate')}
                            subheaderTypographyProps={{color:'#fff', fontSize: '12px' }}
                            style={{ paddingLeft: '33px', backgroundColor: '#7F51F5',color: '#fff' }}

                        />
                            <CardContent>
                                <FormGroup style={{ paddingLeft: '20px' }}>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend" style={{color: 'black', fontSize: '13px'}}>
                                        {t('fillNumber')}
                                    </FormLabel>
                                    <br/>
                                    <TextField 
                                    className={classes.textField}
                                    value = {heartRate}
                                    onChange={event => setHeartRate(event.target.value)}
                                     id="outlined-basic" label="" variant="outlined" size="small"
                                     type="number"
                                     InputProps={{
                                        inputProps: { 
                                            max: 100, min: 0,
                                            style: { paddingLeft: '12%' }
                                        },
                                    }}
                                    error={heartRate<=0}
                                    helperText={heartRate <=0 ? 'Please fill value greater than 0' : ''}
                                    />
                                        
                                    </FormControl>
                                </FormGroup>
                            </CardContent>
                        </Card>
                    </Grid>
                    
                </Grid>     
            </Box>
            {
                checkInput ? 
                    <><br/> <p className={classes.redText}>
                        <span className="font-face-pm">
                        {t('specifyAnswer')}
                        </span>
                    </p></> 
                : <></>
            }
            <Box sx={{ flexGrow: 1 }} pt={3}>
            <Grid container pl={2} pr={2}>
                
                    <Grid item  md={6} xs={6} style={{float: 'left'}}>
                        <div>
                        <CustomCloseBack onClick={() => {history.goBack();}}>BACK</CustomCloseBack>
                        </div>
                    </Grid>
                    <Grid item  md={6} xs={6}>
                        <div style={{float: 'right'}}>
                            <CustomButton onClick={routeChange}>NEXT</CustomButton>
                        </div>
                    </Grid>
            </Grid>     
            </Box>

            <Box sx={{ flexGrow: 1 }} pt={3}>
                <Grid container pl={2} pr={2} direction="column">
                        {
                            localStorage.getItem('totalPageDailyForm') === "4" ?
                                <Grid item  md={12} xs={12}>
                                    <div className={classes.appbar} style={{fontSize: '11px', color: 'grey' , fontWeight: 'bold', float: 'right'}}>
                                        { "Page |" + " 3/" + localStorage.getItem('totalPageDailyForm') }
                                    </div>
                                </Grid>
                            :
                            localStorage.getItem('totalPageDailyForm') === "5" ?
                                <Grid item  md={12} xs={12}>
                                    <div className={classes.appbar} style={{fontSize: '11px', color: 'grey' , fontWeight: 'bold', float: 'right'}}>
                                        { "Page |" + " 3/" + localStorage.getItem('totalPageDailyForm') }
                                    </div>
                                </Grid>
                            :
                            <Grid item  md={12} xs={12}>
                                <div className={classes.appbar} style={{fontSize: '11px', color: 'grey' , fontWeight: 'bold', float: 'right'}}>
                                    { "Page |" + " 5/" + localStorage.getItem('totalPageDailyForm') }
                                </div>
                            </Grid>

                        }
                        
                </Grid>     
            </Box>
            <br/> 
            <br/> 
            <br/> 
        </div>
        </ThemeProvider>
    )
}

export default Temperature
